export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange-13.22b483f2.svg";